/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable max-len */
/**
 * 无标签页面与品质版本首页的公共逻辑部分
 *  如：协议授权、运营活动弹窗、初始化弹窗、大促活动等
 */
import {
  Component, InjectReactive, Mixins,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import isPrerendering from '@/shared/utils/isPrerendering';
import IdenttityScoreMixins from '@/mixins/finance-identity';
import AdvHomePopup from '@/components/adv-components/adv-home-popup';
import AdvHomeFloat from '@/components/adv-components/adv-home-float';
import store from '@/store';
import {
  queryEvent, showAdvert, subscribeTCP, unsubscribeTCP,
} from '@/api/native/kongming';
import isSupportKongMingTCP from '@/shared/utils/isSupportKongMingTCP';
import { RouterV2Enum } from '@/router/router-names';
import { Visit } from '@/enums/tianjiangConf';
import UserCenterFloat from '@/components/user-center-float';
import platform from '@/shared/utils/platform';
import { OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { agreementService } from '@/service/confirm-agreements';
import { Home } from '../../types';
import UpgradeWrapper from '../upgrade-wrapper';
import Autarkey from '../../autarky';

const HomeStore = namespace('home');
const _isPrerendering = isPrerendering();
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const style: Dictionary = require('./index.module.scss');

// 天降红包
const RedPacket = () => import(
  /* webpackChunkName: "red-packet" */'../../components/red-packet'
) as any;

// 额度更新-弹窗
const CreditAmountAlterPopup = () => import(
  /* webpackChunkName: "credit-amount-alter-popup" */'@/pages/home/components/DailogController/CreditAmountAlterPopup/index.vue'
) as any;

// 逾期提醒-弹窗
const RepayOverdueAlterPopup = () => import(
  /* webpackChunkName: "repay-overdue-alter-popup" */'@/pages/home/components/DailogController/RepayOverdueAlterPopup/index.vue'
) as any;

@Component
export default class HomeWrapper extends Mixins(
  IdenttityScoreMixins,
  Autarkey,
) {
  @InjectReactive() homePage!: Home;

  @HomeStore.State isAgreed!: boolean | null;

  /** 孔明 客户端事件轮询 */
  private kongmingTimer: NodeJS.Timer | null = null;

  private unsubscribeTCPPageId = '';

  private get redPacketVisit() {
    return this.$route.path === RouterV2Enum.qualityHomePage ? Visit.Quality : Visit.Tagless;
  }

  private created() {
    if (!_isPrerendering) {
      if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
        this.homePage.correctRouteByCredit();
      } else {
        agreementService.preloadAgreementsData();
        // 更新用户身份证清晰分数据
        this.updatedIdentityScore(OcrProcessSourceEnum.HOME);
      }
    }
  }

  private mounted() {
    if (this.homePage) {
      this.homePage.hideLoading();
    }

    if (_isPrerendering) {
      document.dispatchEvent(new Event('render-event'));
    } else {
      (this.$refs.homePage as HTMLElement).addEventListener(
        'click',
        this.captureGlobalClick.bind(this),
        true,
      );
      // 升级完成提示
      this.showAutarkeyUpgradeTost();
      this.subscribeKMTCP();
    }
  }

  private get PageId(): string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { pageId } = this.$route.meta;
    if (pageId === 'finance_taglessHome') {
      // 孔明事件推送系统给客户端时，不支持一个广告位 id 关联在一个 多个pageId上，首页统一都按品质首页 PageId 来处理
      return 'finance_qualityHomePage';
    }
    if (pageId) {
      return pageId as string;
    }
    return '';
  }

  /** 离开页面时，取消孔明事件订阅，并移除 孔明事件查询定时器 */
  private async unsubscribeKMTCP() {
    if (isSupportKongMingTCP()) {
      // 移除孔明事件轮询定时器
      if (this.kongmingTimer) {
        clearInterval(this.kongmingTimer);
      }

      // 取消事件订阅
      if (this.unsubscribeTCPPageId) {
        await unsubscribeTCP(this.unsubscribeTCPPageId);
      }
    }
  }

  /** 进入页面时 注册订阅孔明事件 并轮询查询 */
  private async subscribeKMTCP() {
    this.unsubscribeTCPPageId = this.PageId;
    if (isSupportKongMingTCP()) {
      if (this.PageId) {
        this.unsubscribeTCPPageId = this.PageId;
        await subscribeTCP(this.PageId);

        this.kongmingTimer = setInterval(async () => {
          const {
            code, advertId,
          } = await queryEvent(this.PageId);
          if (code === 0 && advertId) {
            await showAdvert(this.PageId, advertId);
          }
        }, 1000);
      }
    }
  }

  // 检查快速提现卡片弹窗是否显示并关闭
  public async checkAndCloseQuickWithdrawCard(): Promise<boolean> {
    const upgradeWrapper = this.$refs.upgradeWrapper as {
      checkAndCloseQuickWithdrawCard?: () => Promise<boolean>;
    } | undefined;

    if (upgradeWrapper && typeof upgradeWrapper.checkAndCloseQuickWithdrawCard === 'function') {
      const hasClosed = await upgradeWrapper.checkAndCloseQuickWithdrawCard();
      return hasClosed;
    }
    return false;
  }

  private render() {
    return (
      <div
        ref='homePage'
        class={style.homeWrapper}
      >
        {this.isUpgradeProcessingAndCredited
          ? <UpgradeWrapper ref="upgradeWrapper" />
          : this.$slots.default}
        {!_isPrerendering && (
          <div>
            {/** 天降红包 与 开屏广告位保持互斥，否则从“其他页”返回首页可能会同时展示 */}
            {store.state.base.existTianjiang && <RedPacket visit={this.redPacketVisit} />}
            {/* 天降红包优先 > 其他开屏广告位 */}
            {!store.state.base.existTianjiang && <AdvHomePopup/>}
            {!platform.isWechatMini && <AdvHomeFloat/>}
            {!platform.isWechatMini && <UserCenterFloat />}
            {!platform.isWechatMini && <CreditAmountAlterPopup />}
            {!platform.isWechatMini && <RepayOverdueAlterPopup />}
          </div>
        )}
        {/** 临时放置自定义弹窗组件Teleport， */}
        <div id="dailogController" />
      </div>
    );
  }

  // 捕获所有的点击事件，协议信息正确返回前不允许执行操作
  private captureGlobalClick(event: Event) {
    if (this.isAgreed === null) {
      event.stopPropagation();
    }
  }

  private beforeDestroy() {
    (this.$refs.homePage as HTMLElement).removeEventListener(
      'click',
      this.captureGlobalClick.bind(this),
      true,
    );
    this.unsubscribeKMTCP();
  }
}
